import "./App.css";
import Home from "./pages/Home/Home";
import NotFound from "./pages/NotFound/NotFound";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Header from "./pages/Shared/Header/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import Projects from "./pages/Projects/Projects";
import Contact from "./pages/Contact/Contact";
import AboutMe from "./pages/AboutMe/AboutMe";
import Blogs from "./pages/Blogs/Blogs";
import Footer from "./pages/Shared/Footer/Footer";
import RoadRiderz from "./pages/Projects/ProjectsDetails/RoadRiderz/RoadRiderz";
import HappyHoliday from "./pages/Projects/ProjectsDetails/HappyHoliday/HappyHoliday";
import MedicNucleus from "./pages/Projects/ProjectsDetails/MedicNucleus/MedicNucleus";
import MotorBikeTraining from "./pages/Projects/ProjectsDetails/MotorBikeTraining/MotorBikeTraining";
import RockBand from "./pages/Projects/ProjectsDetails/RockBand/RockBand";
import JinniRelocation from "./pages/Projects/ProjectsDetails/JinniRelocation/JinniRelocation";
import VirtualShop from "./pages/Projects/ProjectsDetails/VirtualShop/VirtualShop";
import BangalTourism from "./pages/Projects/ProjectsDetails/BangalTourism/BangalTourism";
import ServiceA2Z from "./pages/Projects/ProjectsDetails/ServiceA2Z/ServiceA2Z";
import Rondhan from "./pages/Projects/ProjectsDetails/Rondhan/Rondhan";
// import Particles from "react-particles-js";

function App() {
 
  return (
    <div className="Ap">
     
  <BrowserRouter>
      <Header/>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/Home" element={<Home />}></Route>
          <Route path="/Rondhan" element={<Rondhan/>}></Route>
          <Route path="/Projects" element={<Projects/>}></Route>
          <Route path="/ServiceA2Z" element={<ServiceA2Z/>}/>
          <Route path="/JinniRelocation" element={<JinniRelocation/>}></Route>
          <Route path="/RoadRiderzCustomX" element={<RoadRiderz/>}></Route>
          <Route path="/BangalTourism" element={<BangalTourism/>}></Route>
          <Route path="/HappyHolidayTourism" element={<HappyHoliday/>}></Route>
          <Route path="/VirtualShop" element={<VirtualShop/>}></Route>
          <Route path="/MedicNucleus" element={<MedicNucleus/>}></Route>
          <Route path="/MotorBikeTrainingClub" element={<MotorBikeTraining/>}></Route>
          <Route path="/RockBand" element={<RockBand/>}></Route>
          <Route path="/Contact" element={<Contact/>}></Route>
          <Route path="/About" element={<AboutMe/>}></Route>
          <Route path="/Blogs" element={<Blogs/>}></Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <Footer></Footer>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
